import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dc_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

/**
 * Resolve an image URL to render in an <img src>.
 * - Absolute URLs (http, https, data, blob) pass through unchanged.
 * - Relative paths starting with "/" are prepended with the backend URL
 *   so uploaded images served at /api/files/... render correctly across
 *   both preview and production environments.
 * - Empty / null returns "" (the browser won't make a request).
 */
export const resolveImg = (url) => {
  if (!url) return "";
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const formatPrice = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);

export const FREE_SHIPPING_THRESHOLD = 75;
export const FLAT_SHIPPING = 7.99;

export const calcShipping = (subtotal) =>
  subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : FLAT_SHIPPING;

/**
 * Apply a coupon to current totals.
 * coupon = null OR { code, discount_type, discount_value, ... }
 * Returns { discount, shipping, total }
 */
export const applyCouponLocal = (subtotal, coupon) => {
  const baseShipping = calcShipping(subtotal);
  if (!coupon) {
    return { discount: 0, shipping: baseShipping, total: subtotal + baseShipping };
  }
  let discount = 0;
  let shipping = baseShipping;
  if (coupon.discount_type === "percent") {
    discount = Math.min(subtotal, +(subtotal * (coupon.discount_value / 100)).toFixed(2));
  } else if (coupon.discount_type === "fixed") {
    discount = Math.min(subtotal, +Number(coupon.discount_value).toFixed(2));
  } else if (coupon.discount_type === "free_shipping") {
    shipping = 0;
  }
  const total = Math.max(0, subtotal - discount) + shipping;
  return { discount, shipping, total: +total.toFixed(2) };
};
